module.exports = __webpack_public_path__ + "static/media/blue_pin.54c7edce.svg";